module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-3.92f86cab.svg";